interface TableHeaderCellProps {
    label: string;
}

export default ({ label }: TableHeaderCellProps) => {
    return (
        <th scope="col" className="px-3 py-3 bg-white border-b border-gray-200 text-gray-800 text-left font-bold text-base capitalize">
            {label}
        </th>
    );
};
